import { easings } from "react-spring";

export const createFlyingBunStyle = (nthOption) => (bunAnimationStyle) => ({
  opacity: bunAnimationStyle.x
    .to({
      range: [0, 0.2, 0.25, 0.5, 0.75, 0.8, 1],
      output: [0, 1, 1, 1, 1, 1, 0],
    })

    .to((x) => x),

  left: bunAnimationStyle.x
    .to({
      range: [0, 1],
      output: nthOption === 1 ? ["25%", "75%"] : ["75%", "25%"],
      easing: easings.easeInOutSine,
    })

    .to((x) => x),

  bottom: bunAnimationStyle.x
    .to({
      range: [0, 0.5, 1],
      output: ["10%", "55%", "10%"],
      easing: easings.easeInOutSine,
    })

    .to((x) => x),

  transform: bunAnimationStyle.x
    .to({ range: [0, 1], output: [0, 360] })
    .to((x) => `rotate(${nthOption === 2 ? "-" : ""}${x}deg) scale(1.2)`),
});
